<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12SdPGM/tc-custom/9781446358641.jpg?1728851607153" alt="This image is the cover for the book Contemporary Cake Decorating Bible: Stenciling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contemporary Cake Decorating Bible: Stenciling
      </h1>
      <p class="bookDescription body article font2">
        <p>Stenciling is an extremely effective way to add impressive decorations to your cakes and cookies quickly. For the best and most satisfying results, Lindy Smith recommends using laser-cut culinary stencils made from durable food-grade plastic. How you choose to add a stenciled pattern will depend on the effect you wish to achieve and the size of the item to be stencilled. This chapter, taken from <i>The Contemporary Cake Decorating Bible</i>, shows you various techniques using both edible dusts and royal icing; it also shows you how to make your own stencils and some possible other uses.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindy Smith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66f7f11f